<div class="content">
  <div class="prefix-wrapper">
    <ng-content select="[prefix]"></ng-content>
  </div>

  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>

  @if (href) {
    <a [href]="href" [target]="hrefTarget ? hrefTarget : '_self'"></a>
  }

  <div class="suffix-wrapper" layout-horizontal>
    <ng-content select="[suffix]"></ng-content>

    @if (hasChevronRight) {
      <div>
        <rt-icon name="chevron-right"></rt-icon>
      </div>
    }

    @if (isSelected) {
      <div>
        <rt-icon class="check-icon" name="check"></rt-icon>
      </div>
    }
  </div>
</div>

@if (!noDivider) {
  <rt-divider></rt-divider>
}
